import { render, staticRenderFns } from "./communityWechatList.vue?vue&type=template&id=400f2bdc&scoped=true"
import script from "./communityWechatList.vue?vue&type=script&lang=js"
export * from "./communityWechatList.vue?vue&type=script&lang=js"
import style0 from "./communityWechatList.vue?vue&type=style&index=0&id=400f2bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f2bdc",
  null
  
)

export default component.exports